<template>
  <v-row no-gutters>
    <template>
      <div class="p-3">
        <v-card class="mb-3" style="background-color: #f3f6f9;" elevation="0">
          <v-container>
            <div class="text-caption pb-1 indigo--text text--darken-4 font-weight-bold">
              Filter
            </div>
            <v-row>
              <v-col cols="12" md="6">
                <label class="text-caption indigo--text text--darken-4">Berdasarkan status</label>
                <v-select small-chips dense class="pb-0" :items="selectOptions.status" item-text="name"
                  item-value="kode_status" v-model="kode_status" label="Berdasarkan status"
                  @change="onChangeStatus($event)" solo></v-select>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
        <v-card>
          <v-card-title>
            <v-row>
              <v-col md="4" sm="12">
                <v-text-field v-model="search" append-icon="mdi-magnify" label="Cari" single-line @keyup="onKeyup($event)"
                  hide-details></v-text-field>
              </v-col>
            </v-row>
          </v-card-title>
          <v-data-table :headers="headers" :items="listStudent" :search="search" item-key="name" class="elevation-1"
            :server-items-length="count" @pagination="onChangePagination($event)">
            <template v-slot:top>
              <v-toolbar flat>
                <v-toolbar-title>Mahasiswa bimbingan</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
              </v-toolbar>
            </template>
            <template v-slot:item.number="{ index }">
              {{ calculateRowNumber(index) }}
            </template>
            <template v-slot:item.status="{ item }">
              <v-chip class="ma-2 text-grey" small :color="item.status.color">
                <v-icon left>
                  {{ item.status.icon }}
                </v-icon>
                {{ item.status.status }}
              </v-chip>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-badge overlap dot color="red">
                <v-icon color="dark" class="mr-2" @click="onDetailClicked(item.kp_id)">
                  mdi-eye
                </v-icon>
              </v-badge>
              <a :href="onExportSuratPembimbing(item.kp_id)">
                <v-icon color="dark" class="mr-2">
                  mdi-printer
                </v-icon>
              </a>
            </template>
            <template v-slot:no-data>
              Belum ada data
            </template>
          </v-data-table>
        </v-card>
      </div>
    </template>
  </v-row>
</template>
<script>
export default {
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    selectOptions: {
      status: [
        {
          name: 'Semua status',
          kode_status: ''
        },
        {
          name: 'Belum mengunggah berkas',
          kode_status: '7'
        },
        {
          name: 'Menunggu penilaian',
          kode_status: '10'
        },
        {
          name: 'Selesai KP',
          kode_status: '11'
        }
      ]
    },
    kode_prodi: '',
    kode_status: '',
    listStudent: [],
    search: null,
    limit: 10,
    offset: 0,
    count: 10,
    page: 1,
    options: {},
    headers: [
      { text: 'No', value: 'number' },
      {
        text: 'Nama',
        align: 'start',
        value: 'nama',
      },
      { text: 'NIM', value: 'nim' },
      { text: 'Realisasi mulai KP', value: 'realisasi_mulai_kp' },
      { text: 'Lama KP', value: 'lama_kp' },
      { text: 'Perusahaan', value: 'perusahaan' },
      { text: 'Status', value: 'status' },


      { text: 'Actions', value: 'actions', sortable: false },
    ],
  }),
  created() {
  },

  methods: {
    getData() {
      const params = {
        kode_status: this.kode_status,
        limit: this.limit,
        offset: this.offset,
        keyword: this.search
      };
      this.axios.get("/api/dosen/" + this.user.id + "/kp", { params: params }).then((res) => {
        this.listStudent = res.data.data;
        this.count = res.data.count;
        let now = new Date();
        this.listStudent = this.listStudent.map(val => {
          if (val.realisasi_selesai_kp) {
            now = val.realisasi_selesai_kp;
          }
          val.lama_kp = this.$dates.dateDiff(val.realisasi_mulai_kp, now);
          val.realisasi_mulai_kp = this.$dates.dateNoDayNoTime(val.realisasi_mulai_kp);
          val.status = this.setStatusLabel(val.level_aproval_sekarang, val.nilai_angka);

          if (this.$isFTSP) {
            if (val.flag_replacement) {
              val.status = {
                status: 'Non aktif',
                color: 'red lighten-3',
                icon: 'mdi-account-switch'
              }
            }
          }

          if (val.level_aproval_sekarang == 4 || val.level_aproval_sekarang == 1) {
            val.lama_kp = '-';
            val.realisasi_mulai_kp = '-';
          }


          return val;
        });
      })
        .catch((err) => console.log(err, 'err'))
        .finally(() => console.log('successfull'));
    },
    calculateRowNumber(index) {
      return this.limit * (this.page - 1) + index + 1;
    },
    generateRandomString(length) {
      const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

      let result = ' ';
      const charactersLength = characters.length;
      for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
      }
      return '$' + result + '$';
    },
    setStatusLabel(level, nilai_angka) {
      if (this.$isFTSP && (level == 4 || level == 1)) {
          return {
            status: 'Bimbingan proposal',
            color: 'light-blue lighten-5',
            icon: 'mdi-handshake'
          }
      } else if (level == 7) {
        return {
          status: 'Menunggu unggah berkas',
          color: 'light-blue lighten-3',
          icon: 'mdi-file-clock'
        }
      } else if (level == 10 && nilai_angka) {
        return {
          status: 'Sudah dinilai & menunggu berita acara',
          color: 'orange lighten-4',
          icon: 'mdi-file-check'
        }
      } else if (level == 10 && !nilai_angka) {
        return {
          status: 'Menunggu penilaian',
          color: 'orange lighten-3',
          icon: 'mdi-file-check'
        }
      } else if (level == 11) {
        return {
          status: 'Selesai',
          color: 'green lighten-2',
          icon: 'mdi-check'
        }
      }
    },
    onKeyup(event) {
      if (event.keyCode == 13) {
        this.getData();
      }
    },
    onChangePagination(event) {
      this.page = event.page;
      this.limit = event.itemsPerPage;
      this.offset = event.itemsPerPage * (event.page - 1);
      this.getData();
    },
    onChangeStatus(kd) {
      this.kode_status = kd;
      this.getData();
    },
    onDetailClicked(ids) {
      this.$router.push({ name: 'recap-student-read', query: { uuid: ids + '$' + this.generateRandomString(16) } });
    },
    onExportSuratPembimbing(kpId) {
      return this.$baseurl + '/api/cetak/' + kpId + '/surat-bimbingan/' + this.user.id;
    }
  },
}
</script>